import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";

import RecapSettingsButtonAndMenu from "./RecapSettingsButtonAndMenu";
import RecapSettingsDialog from "./RecapSettingsDialog";

const RecapSettings = ({ variant }: { variant: "menu" | "dialog" }) => {
  const transcriptAvailable = useTranscriptStore(
    (state) => state.transcriptAvailable
  );

  // All the settings are related to the transcript/transcript entities. if
  // there's no transcript, no point showing any of the settings
  if (!transcriptAvailable) return null;

  if (variant === "menu") {
    return <RecapSettingsButtonAndMenu />;
  }

  return <RecapSettingsDialog />;
};

export default RecapSettings;
